// extracted by mini-css-extract-plugin
module.exports = {"modal":"CreateBoardModal_modal__2vQx1","modal_background":"CreateBoardModal_modal_background__2kaSU","modal-content":"CreateBoardModal_modal-content__DQ-jR"};